import { Brand } from '../../types'
import { fetchBrands } from '../../services/brands.service'
import createBaseStore from '../createStoreHelper'
import { getters } from './brand.getters'

export const BrandModule = createBaseStore<Brand>({
  resourceName: 'brand',
  apiCalls: {
    fetchAllApiCall: fetchBrands
  }
})

BrandModule.getters = { ...BrandModule.getters, ...getters }
